import { render, staticRenderFns } from "./overviewRatioDeliveredBox.vue?vue&type=template&id=88e6d58a&"
import script from "./overviewRatioDeliveredBox.vue?vue&type=script&lang=ts&"
export * from "./overviewRatioDeliveredBox.vue?vue&type=script&lang=ts&"
import style0 from "./overviewRatioDeliveredBox.vue?vue&type=style&index=0&id=88e6d58a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports